import { h } from "harmaja"
import * as L from "lonna"
import { Board, Connection, Embed } from "../../../common/src/domain"
import { Dispatch } from "../store/board-store"
import { BoardCoordinateHelper } from "./board-coordinates"
import { BoardFocus } from "./board-focus"
import { DragBorder } from "./DragBorder"
import { hostOf } from "./embed-url"
import { itemDragToMove } from "./item-dragmove"
import { itemSelectionHandler } from "./item-selection"
import { ToolController } from "./tool-selection"
import { itemZIndex } from "./zIndices"

// Iframe embed. The iframe only takes pointer events while the item is selected, so the item stays draggable.
export const EmbedView = ({
    id,
    embed,
    board,
    isLocked,
    focus,
    toolController,
    coordinateHelper,
    latestConnection,
    dispatch,
}: {
    board: L.Property<Board>
    id: string
    embed: L.Property<Embed>
    isLocked: L.Property<boolean>
    focus: L.Atom<BoardFocus>
    toolController: ToolController
    coordinateHelper: BoardCoordinateHelper
    latestConnection: L.Property<Connection | null>
    dispatch: Dispatch
}) => {
    const { selected, onClick, onTouchStart } = itemSelectionHandler(
        id,
        "embed",
        focus,
        toolController,
        board,
        coordinateHelper,
        latestConnection,
        dispatch,
    )
    return (
        <span
            className={L.view(selected, (s) => (s ? "embed selected" : "embed"))}
            data-itemid={id}
            draggable={true}
            onClick={onClick}
            onTouchStart={onTouchStart}
            ref={
                itemDragToMove(
                    id,
                    board,
                    focus,
                    toolController,
                    coordinateHelper,
                    latestConnection,
                    dispatch,
                    false,
                ) as any
            }
            style={L.view(embed, (p) => ({
                top: 0,
                left: 0,
                transform: `translate(${p.x}em, ${p.y}em)`,
                height: p.height + "em",
                width: p.width + "em",
                zIndex: itemZIndex(p),
                position: "absolute",
            }))}
        >
            <span className="embed-bar" title="Drag to move">
                {L.view(embed, (e) => hostOf(e.url))}
                <a href={L.view(embed, "url")} target="_blank" rel="noopener noreferrer" title="Open in new tab">
                    ↗
                </a>
            </span>
            <iframe
                src={L.view(embed, "url")}
                sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-presentation"
                allow="autoplay; fullscreen; clipboard-write; encrypted-media; picture-in-picture"
                referrerPolicy="no-referrer-when-downgrade"
                loading="lazy"
            />
            {L.view(isLocked, (l) => l && <span className="lock">🔒</span>)}
            <DragBorder {...{ id, board, toolController, coordinateHelper, latestConnection, focus, dispatch }} />
        </span>
    )
}
